module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("iCWGl"))).then(() => parcelRequire('ljYL6'));